<template>
  <table class="d-table d-table__tasks marg-10-bottom" :class="{'d-table--open': isOpen}">
    <thead @click="setIsOpen" class="pointer acc-header">
    <tr>
      <th class="d-table__title"><h4>{{ title }}</h4></th>
      <th></th>
      <th class="is-number d-table__thead__last">
        <div class="number_and_acc">
          {{ sumOfHours }}
          <span class="icon-arrow-down4" v-if="!isOpen"></span>
          <span class="icon-arrow-up4" v-if="isOpen"></span>
        </div>
      </th>
    </tr>
    </thead>
    <template v-if="isOpen">
      <tbody>
      <tr v-if="tasks.length < 1">
        <td style="width: 90%;">
          <div style="padding: 4px" class="italic"> {{ i18n[locale]['no_subjects_assigned'] }}</div>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr v-for="task in sortedTasks" :key="task.id">
        <td>
          <div class="task-with-edit" @click="setEditTask(task)">
            <div class="subjects_subject subjects_subject__simple"
                 v-if="task.can_schedule || !task.hasOwnProperty('can_schedule')"
                 :style="[{'border-left-color': task.color}, {'background-color': task.color}]">
              {{ task.name }}
            </div>
            <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
          </div>
        </td>
        <td class="td-calendars">
        <span v-if="getShowCalendarIfNotOwn(task)">
          {{ getShowCalendarIfNotOwn(task) }}
        </span>
        </td>
        <td v-if="!task.hasOwnProperty('can_schedule')"
            class="is-number subject-hours-for-person"
            :class="{'subject-hours-for-person--is-modified': getSubjectHours(task.id) !== task.hours}"
            @click="setActiveSubject(task.id)">
          {{ task.vHours != null ? task.vHours.toFixed(1) : '–' }}
        </td>
        <td class="is-number" v-else>
          {{ task.vHours != null ? task.vHours.toFixed(1) : '–' }}
        </td>
      </tr>
      </tbody>
      <tfoot>
      <template v-if="isOpen && tasksWithoutSubject.length > 0">
        <tr class="mini-table">
          <td class="is-number">Med brik</td>
          <td class="is-number"></td>
          <td class="total-hours is-number">
            {{ sumOfHoursWithSubject }}
          </td>
        </tr>
        <tr class="mini-table">
          <td class="is-number">Uden brik</td>
          <td class="is-number"></td>
          <td class="total-hours is-number">
            {{ sumOfHoursWithoutSubject }}
          </td>
        </tr>
      </template>
      <tr class="tfoot-headline">
        <td class="is-number">{{ !isPoolsDeactivated ? i18n[locale]['assigned'] : '' }}</td>
        <td class="is-number">{{ !isPoolsDeactivated ? i18n[locale]['difference'] : '' }}</td>
        <td class="is-number">{{ i18n[locale]['time'] }}</td>
      </tr>
      <tr>
        <td class="is-number">{{ !isPoolsDeactivated ? assignedHours : '' }}</td>
        <td class="is-number">{{ !isPoolsDeactivated ? getDiff : '' }}</td>
        <td class="total-hours is-number">
          {{ sumOfHours }}
        </td>
      </tr>
      </tfoot>
    </template>
  </table>
</template>

<script>
import DDropdown from '../common/DDropdown'

export default {
  components: {DDropdown},
  props: {
    id: {
      type: String,
      default: 'teaching'
    },
    user: {
      type: Object
    },
    userCalendarId: {
      default: 13
    },
    title: {
      type: String,
      default: 'Øvrige opgaver'
    },
    hoursTitle: {
      type: String,
      default: 'Timer'
    },
    tasks: {
      default: () => []
    },
    assignedHours: {
      default: '0.0'
    },
    isTeaching: {
      type: Boolean,
      default: false
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18n: {
        da: {
          no_subjects_assigned: 'Ingen opgaver tildelt',
          assigned: 'Tildelt',
          difference: 'Diff',
          time: 'Timer'
        },
        en: {
          no_subjects_assigned: 'No subjects allocated',
          assigned: 'Allocated',
          from_subjects: 'From subjects',
          difference: 'Diff',
          time: 'Hours'
        },
        nb: {
          no_subjects_assigned: 'Ingen fag tildelt',
          assigned: 'Tildelt',
          from_subjects: 'Fra fag',
          difference: 'Diff',
          time: 'Timer'
        }
      }
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    sortedTasks () {
      return this.tasks.map(task => {
        let vHours = null

        // 1. Forsøg at finde timer for brugerens egen kalender
        if (Array.isArray(task.subject_calendars)) {
          const match = task.subject_calendars.find(sc => sc.calendar_id === this.userCalendarId && sc.hours != null)
          if (match) {
            vHours = parseFloat(match.hours)
          }
        }

        // 2. Ellers prøv første klasses calendar
        if (vHours == null && Array.isArray(task.cals)) {
          const klassCal = task.cals.find(c => c.calendar_type === 'klass')
          if (klassCal && Array.isArray(task.subject_calendars)) {
            const klassMatch = task.subject_calendars.find(sc => sc.calendar_id === klassCal.id && sc.hours != null)
            if (klassMatch) {
              vHours = parseFloat(klassMatch.hours)
            }
          }
        }

        // 3. Fallback til task.hours
        if (vHours == null) {
          const fallback = parseFloat(task.hours)
          vHours = isNaN(fallback) ? 0 : fallback
        }

        return {
          ...task,
          vHours
        }
      }).sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: 'base'
        })
      })
    },
    sumOfHours () {
      const sum = this.sortedTasks.reduce((acc, task) => {
        const val = parseFloat(task.vHours)
        return acc + (isNaN(val) ? 0 : val)
      }, 0)
      return sum.toFixed(1)
    },
    sumOfHoursWithSubject () {
      const sum = this.sortedTasks.reduce((acc, task) => {
        const hasSubject = this.subjectsInHash[task.id]
        if (hasSubject || task.can_schedule) {
          const v = parseFloat(task.vHours)
          return acc + (isNaN(v) ? 0 : v)
        }
        return acc
      }, 0)
      return sum.toFixed(1)
    },
    sumOfHoursWithoutSubject () {
      const sum = this.sortedTasks.reduce((acc, task) => {
        const hasSubject = this.subjectsInHash[task.id]
        if (!hasSubject && !task.can_schedule) {
          const v = parseFloat(task.vHours)
          return acc + (isNaN(v) ? 0 : v)
        }
        return acc
      }, 0)
      return sum.toFixed(1)
    },
    getDiff () {
      return (this.assignedHours - this.sumOfHours).toFixed(1)
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasksWithoutSubject () {
      return this.tasks.filter(task => task.hasOwnProperty('can_schedule') && !task.can_schedule)
    },
    userTableAcc () {
      return this.$store.state.subjects.userTableAcc
    },
    isOpen () {
      return this.userTableAcc[this.id]
    }
  },
  methods: {
    setIsOpen () {
      var current = this.userTableAcc[this.id]
      let obj = {
        title: this.id,
        boolean: current ? !current : true
      }
      return this.$store.commit('setUserTableAcc', obj)
    },
    setEditTask (task) {
      this.$emit('edit', task)
    },
    setDeleteTask (task) {
      this.$emit('delete', task)
    },
    calsToString (cals) {
      if (!cals || !cals.length) return ''
      const names = cals.slice(0, 2).map(cal => cal.name)
      return cals.length > 2 ? names.join(', ') + ' ...' : names.join(', ')
    },
    getShowCalendarIfNotOwn (task) {
      let isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId
      if (isInOwnCalendar) {
        return null
      }
      if (task.cals) {
        const klasses = task.cals.filter(cal => cal.calendar_type === 'klass')
        if (klasses && klasses.length > 0) {
          return this.calsToString(klasses)
        }
      }
      if (task.belongs_to_calendars) {
        return task.belongs_to_calendars.filter(calId => this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId]['name']).join(',')
      }
      return this.allCalendarsInHash[task.calendar_id] ? this.allCalendarsInHash[task.calendar_id]['name'] : []
    },
    getSubjectHours (subjectId) {
      let theSubject = this.subjectsInHash[subjectId]
      let idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(teacher => teacher.user_id === this.user.id) : -1
      if (idx > -1) {
        return theSubject.teachers[idx].hours
      } else {
        return theSubject.hours
      }
    },
    setActiveSubject (subjectId) {
      this.$emit('setActiveSubject', subjectId)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
  width: calc(100% / 3);
}

.d-table > thead > tr:first-child, .d-table > tfoot > .tfoot-headline, .text--grey {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.mini-table td:first-child {
  text-align: left;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff;
  border-radius: 4px;
  word-break: break-all;
  background: transparent;
  overflow: hidden;
  text-align: left;
  margin: 2.5px 5px 2.5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  border-left: 2px solid transparent;
  animation: fadeIn;
  cursor: pointer;
  width: 135px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
}

.subjects_subject.subjects_subject__simple {
  border: 1px solid var(--border-color);
  border-left: 2px solid transparent;
  background: #ffffff !important;
  color: var(--dark-blue);
  box-shadow: none;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background-color: transparent;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  border: 1px solid var(--border-color);
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 65px;
  overflow: hidden;
  font-size: 11px;
}

.subject-hours-for-person {
  position: relative;
  cursor: pointer;
  transition: transform 0.25s;
}

.subject-hours-for-person:hover {
  transform: translateY(-1px);
  text-decoration: underline;
  color: #468AD7;
}

.subject-hours-for-person.subject-hours-for-person--is-modified:after {
  content: "\e904";
  position: absolute;
  bottom: 10px;
  padding: 4px;
  left: 0px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  -webkit-font-feature-settings: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.d-table:not(.d-table--open) > thead > tr > th:first-child,
.d-table:not(.d-table--open) > thead > tr > th:nth-child(3) {
  width: 50%;
}

.d-table:not(.d-table--open) > thead > tr > th:nth-child(2) {
  width: 0;
}

.mini-table td {
  font-weight: normal;
  color: #697386;
}

.number_and_acc {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.number_and_acc span {
  font-size: 0.8rem;
  margin-left: 1rem;
}

.acc-header:hover {
  background-color: #e2e8f0;
}
</style>



// WEBPACK FOOTER //
// SubjectsDistributionUserTable.vue?6b47f55e